<app-steps [step]='2'></app-steps>

<div class="row">
  <div class="col-12">
    <h3 class="main-title text-center">Select Consultation</h3>
  </div>
</div>

<div class="row">
  <div class="col">
    <div id="package" class="carosel">
      <div *ngFor="let consultation of groups; let i = index">

        <div class="card-header custom-card-header rounded-0" data-toggle="collapse"
          [attr.data-target]="'#collapse' + i.toString()" style="cursor: pointer">
          <div class="row">
            <div class="col"><span>{{consultation.name}}</span></div>
            <div class="col text-right"><i class="fas fa-plus"></i></div>
          </div>
        </div>

        <div id="{{'collapse' + i.toString()}}" class="collapse" data-parent="#package">
          <div class="card card-body">

            <div id="service" *ngFor="let service of consultation.treatments; let i = index">
              <div *ngIf="filterService(service)">

                <div class="row custom-padding">
                  <div class="col-md-6 service-title">
                    <span>{{service.name}}</span>
                  </div>
                  <div class="col-md-6 text-right ">
                    <button class="btn btn-default rounded-0 more-info" type="button" data-toggle="collapse"
                      [attr.data-target]="'#collapseInner' + service.info.split(' ').join('') + i.toString()">
                      More info <i class="fas fa-plus"></i>
                    </button>
                    <button class="btn btn-select btn-blue" (click)="setSelectedService(service)">Select &nbsp;<i
                        class="fas fa-chevron-right"></i></button>
                  </div>
                </div>

                <div class="collapse" *ngIf="service.info!=null"
                  id="{{'collapseInner' + service.info.split(' ').join('') + i.toString()}}">
                  <div class="container custom-padding">
                    {{service.description}}
                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #twoYearsTransaction>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Message</h4>
  </div>
  <div class="modal-body">
    <p>It has been over 24 months since your last consultation at Universal Health. 
      Your file has been archived. 
      You can proceed to book an Initial Consultation or please call us on 
      <a href="tel:+612 9302 2888">+612 9302 2888</a> to reactivate your file and schedule an appointment.</p>
  </div>
  <div class="modal-footer">
    <a class="btn btn-blue" (click)="confirmMessageDialog()">Okay</a>
  </div>
</ng-template>

<ng-template #isNewCustomerDialog>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Message</h4>
  </div>
  <div class="modal-body">
    <p>
      Welcome to Universal Health Online Booking. You will now need to book an initial consultation. Please proceed to
      book online or feel free to call us on <a href="tel:+612 9302 2888">+612 9302 2888</a> to discuss further.
    </p>
  </div>
  <div class="modal-footer">
    <a class="btn btn-blue" (click)="confirmMessageDialog()">Okay</a>
  </div>
</ng-template>

<ng-template #covidUpdate>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Coronavirus (COVID-19) Patient Alert</h4>
  </div>
  <div class="modal-body">
    <div class="row">
      <label class="col-12 col-sm-9">Do you have a fever, cough, sore throat, shortness of breath, runny nose or any other flu like symptoms?</label>
      <mat-radio-group class="col-12 col-sm-3" [(ngModel)]="feverOrSorTroat">
        <mat-radio-button value="true">Yes&nbsp;</mat-radio-button>
        <mat-radio-button value="false">No</mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="row">
      <label class="col-12 col-sm-9">Have you been in close contact with a confirmed or suspected COVID case?</label>
      <mat-radio-group class="col-12 col-sm-3" [(ngModel)]="contactWithConvidPatient">
        <mat-radio-button value="true">Yes&nbsp;</mat-radio-button>
        <mat-radio-button value="false">No</mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="row">
      <label class="col-12 col-sm-9">Have you links to any setting where a COVID outbreak has occurred (incl. a suburb, LGA, hotspot, community or venue)?</label>
      <mat-radio-group class="col-12 col-sm-3" [(ngModel)]="travell30Days">
        <mat-radio-button value="true">Yes&nbsp;</mat-radio-button>
        <mat-radio-button value="false">No</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>
  <div class="modal-footer">
    <a class="btn btn-blue" (click)="checkCovid()">Submit</a>
  </div>
</ng-template>


<ng-template #covidBlocker>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Message</h4>
  </div>
  <div class="modal-body">
    <p>Please contact the clinic on +612 9302 2888 before making an appointment or attending the clinic.</p>
  </div>
  <div class="modal-footer">
    <a class="btn btn-blue" (click)="clodeDialog()">Okay</a>
  </div>
</ng-template>


<ng-template #unlimtedModal>
  <div class="modal-header">
    <h4 class="modal-title pull-left">TELEHEALTH CONSULTATIONS</h4>
  </div>
  <div class="modal-body">
    <p>As part of our work to support our patients and communities, you can book a non-rebatable Telehealth consultation
      with any of our Practitioners.
    </p>
    <p>
      Telehealth offers peace of mind for patients who are concerned about attending our clinic in person.
    </p>
    <p>
      Book Telehealth by calling our clinic on +612 9302 2888
    </p>
  </div>
  <div class="modal-footer">
    <a class="btn btn-blue" (click)="clodeDialog()">Okay</a>
  </div>
</ng-template>